import React from 'react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ReactComponent as IconClose } from '../../design-system/design_system/assets/icons/system/close.svg';
export default function FlexPanel(props) {
    const handlecloseBtn=()=>{
       props.closeBtnFn();
    }
    return (
        <>
           <div id={props.containerId} className="flex-panel" data-testid="flex-panel">
                <div className='flex-panel-info'>
                    {props.calenderHeadingFlag && 
                     <h4 className='flex-panel-label'>{props.title}</h4>}
                   {props.closeBtnFlag &&
                    <Button onClick={handlecloseBtn} data-testid="close_btn"  variant='ghost' size={''} className='close-btn'>
                        <IconClose className="svg-fill-gray" />
                    </Button> 
                   }
                                
                </div>
                <div className='flex-panel-content'>
                    {props.children}
                </div>

            </div>
        </>
    )
}

